import { lazy, FC, RefObject } from 'react';
import { useFragment, graphql } from 'react-relay';

import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';
import type { PdpRespSidebarPillsLazy_item$key } from './__generated__/PdpRespSidebarPillsLazy_item.graphql';

const PdpRespSidebarPills = lazy(
    () => import(/* webpackChunkName: "PdpRespSidebarPills" */ './PdpRespSidebarPills')
);

type Props = {
    item: PdpRespSidebarPillsLazy_item$key;
    scrollToCustomizationRef: RefObject<HTMLElement>;
};

const itemFragment = graphql`
    fragment PdpRespSidebarPillsLazy_item on Item {
        ...PdpRespSidebarPills_item
    }
`;

export const PdpRespSidebarPillsLazy: FC<Props> = ({ item: itemRef, scrollToCustomizationRef }) => {
    const item = useFragment(itemFragment, itemRef);
    return (
        <ClientSuspense fallback={null}>
            <PdpRespSidebarPills item={item} scrollToCustomizationRef={scrollToCustomizationRef} />
        </ClientSuspense>
    );
};
